import { Button, Card, Form, Input, Message, Modal, Space, Table } from "@arco-design/web-react"
import OperationButton from "@/components/OperationButton";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { StatusDef, InventoryStatusDef, InventoryStatus, Status } from "@/enums/status";
import { useEffect, useState } from "react";
import { WarehouseAPI } from "@/apis/material";
import { WarehouseInfo } from "./warehouse-info";
import { useCallback } from "react";
import { Link } from "react-router-dom";
import { IconCheck, IconClose } from "@arco-design/web-react/icon";

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const AddWarehouseButton = ({ onOk }) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [initialValues] = useState({ inventoryStatus: InventoryStatus.Available });

    const submit = async () => {
        try {
            const values = await form.validate();
            await WarehouseAPI.add(values);
            Message.success("Warehouse created successfully")
            setVisible(false);
            onOk && onOk();
        } catch (error) {
            Message.error(error.message);
        }
    }

    return (
        <>
            <Button type="primary" onClick={() => {
                setVisible(true);
            }}>Add New Warehouse</Button>

            <Modal title="Add New Warehouse" visible={visible}
                style={{ width: 550 }}
                afterClose={() => form.resetFields()}
                onCancel={() => setVisible(false)}
                onOk={() => submit()}
            >
                <Form form={form} colon
                    initialValues={initialValues}
                    labelCol={{ span: 9 }}
                    wrapperCol={{ span: 14 }}>
                    <FormItem field="id" hidden>
                        <Input />
                    </FormItem>
                    <FormItem field="warehouseNumber" label="Warehouse Number" required rules={[{ required: true }]}>
                        <Input />
                    </FormItem>
                    <FormItem field="warehouseName" label="Warehouse Name" required rules={[{ required: true }]}>
                        <Input />
                    </FormItem>
                    <FormItem field="inventoryStatus" label="Inventory" required rules={[{ required: true }]}>
                        <EnumSelect enumObj={InventoryStatusDef} />
                    </FormItem>
                    <FormItem field="note" label="Notes">
                        <TextArea />
                    </FormItem>
                </Form>
            </Modal>
        </>
    )
}

export const Warehouse = () => {
    const [status, setStatus] = useState();
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);

    const getWarehouses = useCallback(async () => {
        const values = await WarehouseAPI.query(page, { status: status });
        setData(values.records);
        setTotal(values.total);
    }, [page, status]);

    useEffect(() => {
        getWarehouses();
    }, [getWarehouses]);

    return (
        <Card title="Warehouse" extra={
            <Space>
                <EnumSelect enumObj={StatusDef} style={{ width: 100 }} value={status} allowAll placeholder="Status"
                    onChange={(val) => {
                        setStatus(val);
                    }} />
                <AddWarehouseButton onOk={() => getWarehouses()} />
            </Space>
        }>
            <Table rowKey="id" columns={[
                { title: "Warehouse Number", dataIndex: "warehouseNumber" },
                { title: "Warehouse Name", render: (col, record) => <Link to={`/workspace/settings/warehouse/${record.id}`} >{record.warehouseName}</Link> },
                {
                    title: "Status",
                    render: (col, record) => <EnumLabel enumObj={StatusDef} value={record.status} />
                },
                { title: "Inventory", dataIndex: "inventoryStatus", render: (col, record) => <EnumLabel enumObj={InventoryStatusDef} value={record.inventoryStatus} /> },
                { title: "Notes", dataIndex: "note" },
                {
                    title: "Operations",
                    render: (col, record) => (
                        <Space size="mini">
                            {record.status === Status.Active &&
                                <OperationButton icon={<IconClose />} label="Disable" status="danger"
                                    confirmTitle="Are you sure you want to disable this warehouse?"
                                    onConfirm={async () => {
                                        try {
                                            await WarehouseAPI.disable(record.id);
                                            Message.success("Warehouse disabled");
                                            getWarehouses();
                                        } catch (error) {
                                            Message.error(error.message);
                                        }
                                    }} />
                            }
                            {record.status === Status.Inactive &&
                                <OperationButton icon={<IconCheck />} label="Enable" status="success"
                                    confirmTitle="Are you sure you want to enable this warehouse?"
                                    onConfirm={async () => {
                                        try {
                                            await WarehouseAPI.enable(record.id);
                                            Message.success("Warehouse enabled");
                                            getWarehouses();
                                        } catch (error) {
                                            Message.error(error.message);
                                        }
                                    }} />
                            }
                        </Space>
                    )
                },
            ]} data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)} />

        </Card>
    )
}

Warehouse.Info = WarehouseInfo;